import { AuthException } from "./auth.exception";

export class TokenExpiredException extends AuthException {
  constructor() {
    super('Token has expired.');
  }
}